import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  login_request: false,
  login_sucess: false,
  login_failed: false,
  auth: undefined,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.login_request = true;
      state.login_sucess = false;
      state.login_failed = false;
    },
    loginSuccess: (state, action) => {
        state.login_request = false;
        state.login_sucess = true;
        state.login_failed = false;
        state.auth = action.payload
    },
    loginFailed: (state) => {
        state.login_request = false;
        state.login_sucess = false;
        state.login_failed = true;
    },
    updateUserData: (state, action) => {
      
      if(state.auth){
        state.auth.user = action.payload;
      }
    },
  },
})
export const { loginRequest, loginSuccess, loginFailed, updateUserData } = authSlice.actions

export default authSlice.reducer